<mat-tab-group class="nested-downloads-tabs" [mat-stretch-tabs]="false" animationDuration="0ms">
  <mat-tab label="Installers" *ngIf="hasInstallers">
    <ng-template matTabContent>
      <div class="downloads-tab-panel" id="downloads-section-installers">
        <app-installers [installers]="archived.installs" [product]="product"></app-installers>
      </div>
    </ng-template>
  </mat-tab>

  <mat-tab label="ISOs" *ngIf="hasIsos">
    <ng-template matTabContent>
      <div class="downloads-tab-panel" id="downloads-section-isos">
        <app-isos [isos]="archived.isos" [product]="product"></app-isos>
      </div>
    </ng-template>
  </mat-tab>

  <mat-tab label="API Docs" *ngIf="hasApi">
    <ng-template matTabContent>
      <div class="downloads-tab-panel" id="downloads-section-api">
        <app-docs [docs]="archived.api" [product]="product"></app-docs>
      </div>
    </ng-template>
  </mat-tab>

  <mat-tab label="Upgrades" *ngIf="hasUpgrades">
    <ng-template matTabContent>
      <div class="downloads-tab-panel" id="downloads-section-upgrades">
        <app-installers [installers]="archived.upgrades" [product]="product"></app-installers>
      </div>
    </ng-template>
  </mat-tab>

  <mat-tab label="Bundles" *ngIf="hasBundles">
    <ng-template matTabContent>
      <div class="downloads-tab-panel" id="downloads-section-bundles">
        <app-installers [installers]="archived.bundles" [product]="product"></app-installers>
      </div>
    </ng-template>
  </mat-tab>

  <mat-tab label="Documentation" *ngIf="hasDocumentation">
    <ng-template matTabContent>
      <div class="downloads-tab-panel" id="downloads-section-docs">
        <app-docs [docs]="archived.documentation" [product]="product"></app-docs>
      </div>
    </ng-template>
  </mat-tab>
</mat-tab-group>
